const INDUSTRY_PRESET_HASH = /^#i-([a-z0-9]+(?:-[a-z0-9]+)*)$/u;

export function industryPresetSlugFromHash(hash: string): string | null {
  return INDUSTRY_PRESET_HASH.exec(hash)?.[1] ?? null;
}

export function currentIndustryPresetIntentHash(): string {
  if (typeof window === "undefined") {
    return "";
  }

  return industryPresetSlugFromHash(window.location.hash) === null
    ? ""
    : window.location.hash;
}

export function hasCurrentIndustryPresetIntent(): boolean {
  return currentIndustryPresetIntentHash() !== "";
}

export function hrefWithCurrentIndustryPresetIntent(href: string): string {
  return `${href}${currentIndustryPresetIntentHash()}`;
}

export function startIndustryPresetIntent(industrySlug: string): void {
  if (typeof window === "undefined" || industryPresetSlugFromHash(`#i-${industrySlug}`) === null) return;

  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${window.location.search}#i-${industrySlug}`,
  );
  window.dispatchEvent(new Event("hashchange"));
}

export function clearIndustryPresetIntent(): void {
  if (typeof window === "undefined") return;

  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${window.location.search}`,
  );
  window.dispatchEvent(new Event("hashchange"));
}
